import { render, staticRenderFns } from "./zhishi.vue?vue&type=template&id=a3f4f83c&scoped=true&"
import script from "./zhishi.vue?vue&type=script&lang=js&"
export * from "./zhishi.vue?vue&type=script&lang=js&"
import style0 from "./zhishi.vue?vue&type=style&index=0&lang=css&"
import style1 from "./zhishi.vue?vue&type=style&index=1&id=a3f4f83c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f4f83c",
  null
  
)

export default component.exports